import React from 'react'
import WeischerItem from './WeischerItem'

const WeisherHero = ({overviewHeroItems, features}) => {
    const  loginHeaderClassName = features && features.has_userbar ? ' has-login-header' : ''

    return ([
            overviewHeroItems.map((item, index) => <WeischerItem 
                key={index} 
                wrapperClassName={'weischer-overview-hero-container' + loginHeaderClassName}
                itemClassName="weischer-overview-hero"
                item={item}
            />)
    ])
}

export default WeisherHero